module.exports = __webpack_public_path__ + "img/ico28.4d5fbd3f.jpg";